import { Directive, HostBinding, HostListener } from '@angular/core';
import { IntercomService } from '@app/shared/services/intercom.service';
@Directive({
  selector: '[appOpenIntercom]',
})
export class OpenIntercomDirective {
  @HostBinding('class.open-intercom-bot')
  public readonly intercomClass = true;

  public constructor(private intercomService: IntercomService) {}

  @HostListener('click')
  public onClick(): void {
    this.intercomService.show();
  }
}
